import React from "react";
import { classNames } from "../../../../helpers/classNames";
import { lngDetect } from "../../../../helpers/lngDetect";
import Image from "../../../../components/elements/Image";
import { useMutation } from "@tanstack/react-query";
import { changeOrganization } from "../../../../services/organizationService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { setOrganization } from "../../../../redux/slice/organizationSlice";
import { useTranslation } from "react-i18next";

const OrganizationItem = ({ item, selectedOrganization }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { lang } = useSelector((state) => state?.langProvider);
  const { selectedOrganizationDetails } = useSelector(
    (state) => state?.organization
  );
  const user_role = selectedOrganizationDetails?.data?.verificationData?.role;

  const { mutate: organizationChangeHandler, isPending: changeInPending } =
    useMutation({
      mutationFn: async (item) => {
        const res = await changeOrganization({
          organization: item?.organizationData?._id,
        });
        if (res?.status === 200) {
          dispatch(setOrganization(res?.data?.organizationData?._id));
        }
        // this is using for route access if auth role is not promoter (on selected organizer) then config the route by auth user role so first configure all the routes then proceed to move next steps
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(res);
          }, 700);
        });
      },
      onSuccess: (res) => {
        if (res?.status === 200) {
          sessionStorage.setItem(
            "organization",
            res?.data?.organizationData?._id
          );
          localStorage.setItem(
            "organization",
            res?.data?.organizationData?._id
          );
          if (res?.data?.role !== "promoter") {
            navigate(
              `/${lang}/user/organization/settings/${res?.data?.organizationData?.uid}`
            );
          }
        }
      },
    });

  return (
    <div
      onClick={() => {
        if (item?.status !== "invited") {
          organizationChangeHandler(item);
        }
      }}
      className={classNames(
        "group overflow-hidden relative shadow rounded-lg cursor-pointer transition-all duration-300  border border-transparent flex flex-col px-5 py-5 h-full",
        "hover:shadow-xl hover:shadow-primary/10 hover:border-primary/10 hover:no-underline",
        selectedOrganization === item?.organizationData?._id
          ? "!border-primary/60 !no-underline"
          : "",
        item?.status === "invited" ? "!opacity-30 !cursor-not-allowed" : ""
      )}
    >
      <div className="flex items-start gap-4 mb-5">
        <div className="w-14 h-14 rounded-lg overflow-hidden bg-primary/10 border border-primary flex-shrink-0">
          <Image
            src={item?.organizationData?.logo?.url}
            alt={
              lngDetect(item?.organizationData?.name) ||
              item?.organizationData?.logo?.url
            }
            classes={"object-cover"}
          />
        </div>

        <div className="space-y-3 flex-grow flex-shrink">
          <h3 className="text-base font-bold text-slate-900 group-hover:text-primary transition-all duration-300 leading-tight">
            {lngDetect(item?.organizationData?.name)}
          </h3>
          {item?.organizationData?.description &&
            (() => {
              const desc = lngDetect(item.organizationData.description);
              const hasHTML = /<\/?[a-z][\s\S]*>/i.test(desc);
              return hasHTML ? (
                <p
                  className="text-sm text-slate-500 line-clamp-4 font-Nunito mt-1"
                  style={{ wordBreak: "break-word" }}
                  dangerouslySetInnerHTML={{ __html: desc }}
                ></p>
              ) : (
                <p
                  className="text-sm text-slate-500 line-clamp-4 font-Nunito mt-1"
                  style={{ wordBreak: "break-word" }}
                >
                  {desc}
                </p>
              );
            })()}
        </div>
      </div>

      {user_role !== "promoter" && (
        <div className="mt-auto flex justify-end">
          <button className="text-sm font-semibold text-primary hover:underline inline-flex items-center gap-1 transition">
            {t("Manage")}
            <i className="fa fa-arrow-right text-xs"></i>
          </button>
        </div>
      )}
      {changeInPending && (
        <div className="absolute top-0 left-0 w-full h-full bg-black/20 backdrop-blur-[2px] flex items-center justify-center font-semibold text-sm">
          {t("Updating")}...
        </div>
      )}
    </div>
  );
};

export default OrganizationItem;
